/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, InlineNotification } from '@coursera/cds-core';

import _t from 'i18n!nls/accomplishments';

const styles = {
  secondaryTextMessage: css`
    margin-bottom: var(--cds-spacing-200);
  `,
};
const VerifyNameNotification = () => (
  <InlineNotification
    actions={
      <Button
        component="a"
        size="small"
        variant="primary"
        href="/user-verification"
        target="_blank"
        rel="noopener noreferrer"
        role="button"
      >
        {_t('Verify my name')}
      </Button>
    }
    severity="warning"
    css={styles.secondaryTextMessage}
  >
    {_t('To ensure your name appears on your certificate, please complete the verification process.')}
  </InlineNotification>
);

export default VerifyNameNotification;
